import resso from 'resso'

export const HomeStore = resso({
  strategy_id: undefined,
  banners: [] as any[],
  quicklyCreate: {
    title: '一键成片',
    list: [
      {
        id: 1,
        title: '单人口播',
        preview_url:
          'https://hf-cdn-dev.lingverse.co/395d5838cfe00b8a02a9bc2ab467bad7/6849A7FF/hf/local/233/videos/Emily/03.mp4',
        cover_url:
          'https://hf-cdn-dev.lingverse.co/395d5838cfe00b8a02a9bc2ab467bad7/6849A7FF/hf/local/233/videos/Emily/03.mp4?x-oss-process=video/snapshot,t_0,m_fast,ar_auto'
      },
      {
        id: 2,
        title: '双人博客',
        tag: {
          background_color: '#d04e49',
          text: '推荐'
        },
        preview_url:
          'https://hf-cdn-dev.lingverse.co/017b2a7dc3bb80003868dc8c788a4852/6849A7FF/hf/local/233/videos/Emily/06.mp4',
        cover_url:
          'https://hf-cdn-dev.lingverse.co/017b2a7dc3bb80003868dc8c788a4852/6849A7FF/hf/local/233/videos/Emily/06.mp4?x-oss-process=video/snapshot,t_0,m_fast,ar_auto'
      },
      {
        id: 3,
        title: '双人博客',
        preview_url:
          'https://hf-cdn-dev.lingverse.co/5ec6092cfd1e00d410eb8ffb0ec303a0/6849A7FF/hf/local/233/videos/Emily/01.mp4',
        cover_url:
          'https://hf-cdn-dev.lingverse.co/5ec6092cfd1e00d410eb8ffb0ec303a0/6849A7FF/hf/local/233/videos/Emily/01.mp4?x-oss-process=video/snapshot,t_0,m_fast,ar_auto'
      },
      {
        id: 4,
        title: '双人博客',
        preview_url:
          'https://hf-cdn-dev.lingverse.co/395d5838cfe00b8a02a9bc2ab467bad7/6849A7FF/hf/local/233/videos/Emily/03.mp4',
        cover_url:
          'https://hf-cdn-dev.lingverse.co/395d5838cfe00b8a02a9bc2ab467bad7/6849A7FF/hf/local/233/videos/Emily/03.mp4?x-oss-process=video/snapshot,t_0,m_fast,ar_auto'
      },
      {
        id: 5,
        title: '双人博客',
        preview_url:
          'https://hf-cdn-dev.lingverse.co/395d5838cfe00b8a02a9bc2ab467bad7/6849A7FF/hf/local/233/videos/Emily/03.mp4',
        cover_url:
          'https://hf-cdn-dev.lingverse.co/395d5838cfe00b8a02a9bc2ab467bad7/6849A7FF/hf/local/233/videos/Emily/03.mp4?x-oss-process=video/snapshot,t_0,m_fast,ar_auto'
      }
    ]
  } as any,
  scenes: [] as any[],
  scene_title: '',
  shortcuts: [] as any[],
  shortcut_title: ''
})
